import { BaseModel } from './base';

export class bookingApproval extends BaseModel {
  staffName: string;
  userId: string;
  id: string;
}
